import { getWeek } from 'date-fns'
import { useEffect, useState } from 'react'

import useCurrentUser from '~/hooks/useCurrentUser'
import { useTimeSpentWeeklyStatsQuery } from '~/redux/apis/user-stats-api'

interface ReturnType {
  data: {
    averageValue: number
    dailyUseData: number[]
    weekNumber: number
    max: number
    zeroData: boolean
  }
  isLoading: boolean
  isError: boolean
}
export default function useWeeklyTimeSpentReport(): ReturnType {
  const user = useCurrentUser()
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const [date] = useState(new Date())
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState({
    averageValue: 0,
    dailyUseData: [0, 0, 0, 0, 0, 0, 0],
    max: 15,
    zeroData: true,
  })

  const weekNumber = getWeek(date, {
    weekStartsOn: 1,
  })
  const dateTimeStr = date.toISOString()

  const {
    data: timeSpentReport,
    isLoading: isQueryLoading,
    isError,
  } = useTimeSpentWeeklyStatsQuery({ dateTime: dateTimeStr, timezone }, { skip: user == null })

  useEffect(() => {
    if (!isQueryLoading && timeSpentReport) {
      const { average, uses } = timeSpentReport

      const dailyUseData = uses.map((use) => (use === null ? 0 : use))
      const zeroData = Boolean(dailyUseData?.every((useData) => useData === 0))
      const max = Math.max(...dailyUseData, 15) || 15

      setIsLoading(false)
      setData({
        averageValue: average,
        dailyUseData,
        zeroData,
        max,
      })
    }
  }, [isQueryLoading, timeSpentReport])

  return {
    data: { ...data, weekNumber },
    isLoading,
    isError,
  }
}
